import React, { Component } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { AutoLogoutTimer } from './components/AutoLogoutTimer';
import { SignUp } from './components/pages/SignUp';
import { ForgotPassword } from './components/pages/ForgotPassword';
import { ResetPassword } from './components/pages/ResetPassword';
import { ConfirmEmail } from './components/pages/ConfirmEmail';
import { Welcome } from './components/pages/Welcome';
import { Dashboard } from './components/pages/Dashboard';
import { PracticeLocationInfo } from './components/pages/Application/Professional/PracticeLocationInfo';
import { PracticeContactInfo } from './components/pages/Application/Common/PracticeContactInfo';
import { ProviderInformation } from './components/pages/Application/Professional/ProviderInformation';
import { PracticeInformation } from './components/pages/Application/Common/PracticeInformation';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheckCircle, faInfoCircle, faTimesCircle, faEnvelopeOpenText, faTrash, faAngleDown, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import './scss/App.scss';
library.add(faCheckCircle, faTimesCircle, faInfoCircle, faEnvelopeOpenText, faTrash, faAngleDown, faAngleRight);

export default class App extends Component {
    static displayName = App.name;
    render() {
        return (
            <Layout>
                <AutoLogoutTimer />

                <Routes>
                {/*// unsecured*/}
                    <Route exact path='/' element={<Welcome/>} />
                    <Route exact path='/signup' element={<SignUp/>} />
                    <Route exact path='/ForgotPassword' element={<ForgotPassword />} />
                    <Route exact path='/ConfirmEmail' element={<ConfirmEmail />} />

                    {/*// secured*/}
                    <Route exact path='/Dashboard' element={<Dashboard />} />
                    <Route exact path='/ResetPassword' element={<ResetPassword />} />
                    <Route exact path='/PracticeLocationInfo' element={<PracticeLocationInfo />} />
                    <Route exact path='/practiceContactInfo' element={<PracticeContactInfo />} />
                    <Route exact path='/practiceInformation' element={<PracticeInformation />} />
                    <Route exact path='/providerInformation' element={<ProviderInformation />} />
                </Routes>
            </Layout>
        );
    }
}
